import React, { ComponentPropsWithoutRef, ForwardedRef, forwardRef, useContext } from 'react';
import * as ListItem from 'components/list-item';
import { SelectContext } from 'components/select/SelectContext';

const SelectAllListItem = forwardRef(
    (props: ComponentPropsWithoutRef<'li'>, ref: ForwardedRef<HTMLLIElement>) => {
        const {
            onMouseEnter: onMouseEnterConsumer,
            onClick: onClickConsumer,
            ...restProps
        } = props;
        const { items, selectedItems, selectAll, deselectAll, setHighlightedIndex } =
            useContext(SelectContext);
        const areAllSelected = selectedItems?.length === items.length;

        const onMouseEnter = (e: React.MouseEvent<HTMLLIElement>) => {
            setHighlightedIndex(-1);

            onMouseEnterConsumer?.(e);
        };

        const onClick = (e: React.MouseEvent<HTMLLIElement>) => {
            areAllSelected ? deselectAll() : selectAll();

            onClickConsumer?.(e);
        };

        return (
            <ListItem.Root ref={ref} onMouseEnter={onMouseEnter} onClick={onClick} {...restProps}>
                <strong>{areAllSelected ? 'Deselect All' : 'Select All'}</strong>
            </ListItem.Root>
        );
    },
);

export { SelectAllListItem };
